export const ETF_TAVAN_ISIN = 'IRT3TVAF0001';
